module.exports = __webpack_public_path__ + "img/number_2.f872952e.png";